import axios from "axios";

export const funciones_s3 = {
  
  get_url_s3: async function(hostname, keys3, archivo="", opcion, bucket=""){
    return new Promise(function(resolve, reject) {      
      var type = ""
      if(archivo !="")
        type =  archivo.type;
      if (bucket=="")
        bucket = "skyticket"      
      var datos = {
          key: keys3,
          bucket: bucket,
          type: type,
          option: opcion,
      }
      //console.log(datos);
      axios.post(hostname + 's3/get_url/', datos)
              .then((res) => {                  
                  resolve(res.data);                  
              })
              .catch((error) => {
                  console.log("get_url_s3",error);
                  reject(error);
              });
    });    
  },

  upload_file_s3: async function(self, keys3, archivo, bucket=""){
    return new Promise(async function(resolve, reject) {      
      try {
        let urlput = await funciones_s3.get_url_s3(self.$hostname, keys3, archivo, "upload", bucket);
        console.log(urlput);
        axios.put(urlput, archivo, {headers:{'Content-Type': archivo.type}})
        .then((res) => {
          resolve(true);                                      
        })                            
        .catch((error)=>{        
          console.log(error);  
          reject("Ocurrió un erro al cargar el archivo en S3. Favor de comunicarse con soporte.")                        
        });        
      } catch (error) {
          console.log("upload_file_s3",error);
          reject("Error al intentar subir el archivo a s3");
      }      
    });    
  },

  download_file_s3: async function(self, keys3, bucket=""){
    return new Promise(async function(resolve, reject) {      
      try {
        let urls3 = await funciones_s3.get_url_s3(self.$hostname, keys3, "", "download", bucket);
        console.log(urls3);        
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = urls3;
        a.target = "_blank";
        a.click();
        a.parentNode.removeChild(a);
        resolve(true);
      } catch (error) {
          console.log("download_file_s3",error);
          reject("Error al intentar descargar el archivo a s3");
      }      
    });    
  },
  
}
